//* Libraries imports
import { FaTrophy, FaClock, FaFileAlt, FaExclamationTriangle } from "react-icons/fa";
import { motion } from "framer-motion";
import styles from "../styles/process-essay-actions.module.scss";

//* Components imports
import Icon from "../../../../../../components/common/Icon";

type ProcessEssayActionsProps = {
  examId: string;
  textoRedacaoId?: number;
  correctionStatus?: string;
  onViewClick?: () => void;
  onResultsClick?: (textoRedacaoId: number) => void;
  hideView?: boolean;
  hideResults?: boolean;
};

export function ProcessEssayActions({
  examId,
  textoRedacaoId,
  correctionStatus,
  onViewClick,
  onResultsClick,
  hideView = false,
  hideResults = false,
}: ProcessEssayActionsProps) {  const buttonVariants = {
    hover: { scale: 1.1, transition: { duration: 0.2 } },
    tap: { scale: 0.9 },
  };
  
  // Can show results if textoRedacaoId exists (regardless of status)
  const canShowResults = textoRedacaoId && textoRedacaoId > 0;
  
  // Determine button text and class based on status and textoRedacaoId
  const getStatusButtonConfig = () => {
    if (!textoRedacaoId) {      return {
        text: "Não Digitalizada",
        class: styles.notDigitalizedButton,
        icon: <Icon icon={FaExclamationTriangle} size={16} />,
        clickable: false,
        title: "Redação não foi digitalizada ainda"
      };
    }
    
    if (correctionStatus === "CORRIGIDA") {      return {
        text: "Corrigido",
        class: styles.correctedButton,
        icon: <Icon icon={FaTrophy} size={16} />,
        clickable: true,
        title: "Ver Correção da Redação"
      };
    }
      return {
      text: "Pendente",
      class: styles.pendingButton,
      icon: <Icon icon={FaClock} size={16} />,
      clickable: true,
      title: "Ver Redação (Aguardando Correção)"
    };
  };
  
  const statusConfig = getStatusButtonConfig();
  
  return (    <div className={styles.actionsContainer}>
      {/* Status Button - Shows correction status */}
      <motion.div
        variants={buttonVariants}
        whileHover="hover"
        whileTap="tap"
        className={`${styles.actionButton} ${statusConfig.class}`}
        onClick={statusConfig.clickable && canShowResults && onResultsClick ? () => onResultsClick(textoRedacaoId!) : undefined}
        title={statusConfig.title}
        role="button"
        aria-label={statusConfig.title}
        style={{ cursor: statusConfig.clickable && canShowResults ? 'pointer' : 'default' }}
      >
        {statusConfig.icon}
        <span className={styles.buttonText}>{statusConfig.text}</span>
      </motion.div>
      
      {/* Quick View Button - Secondary action for all essays */}
      {onViewClick && !hideView && (
        <motion.div
          variants={buttonVariants}
          whileHover="hover"
          whileTap="tap"
          className={`${styles.actionButton} ${styles.viewButton}`}
          onClick={onViewClick}
          title="Visualizar redação"
          role="button"
          aria-label="Visualizar detalhes da redação"        >
          <Icon icon={FaFileAlt} size={14} />
        </motion.div>
      )}
    </div>
  );
}
